// auth-authorization.guard.ts

import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizationService } from '../../services';

@Injectable({
  providedIn: 'root'
})
export class AuthAuthorizationGuard implements CanActivate {

  constructor(
    private readonly authorizationService: AuthorizationService,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    
    const permisoId = route.data['permission'] as number;

    return new Promise((resolve) => {
     
      this.authorizationService.cargarPermisos().then(() => {
        if (this.authorizationService.tienePermiso(permisoId)) {
          resolve(true); 
        } else {
          this.router.navigate(['/home']); 
          resolve(false); 
        }
      });
    });
  }
}
